import { render, staticRenderFns } from "./ClientsItemSkeleton.vue?vue&type=template&id=e7a747d2&scoped=true&lang=pug&functional=true&"
import script from "./ClientsItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./ClientsItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ClientsItemSkeleton.vue?vue&type=style&index=0&id=e7a747d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "e7a747d2",
  null
  
)

export default component.exports